const initSwiperIntro = () => {
  const swiperElement = document.querySelector('[data-swiper="intro"]');
  const swiperButtonPrev = document.querySelector(
    '[data-swiper-button-prev="intro"]'
  );
  const swiperButtonNext = document.querySelector(
    '[data-swiper-button-next="intro"]'
  );

  const pagination = document.querySelector('[data-swiper-pagination="intro"]');

  if (!swiperElement) return;

  const swiper = new Swiper(swiperElement, {
    loop: true,
    navigation: {
      nextEl: swiperButtonPrev,
      prevEl: swiperButtonNext,
    },
    pagination: {
      el: pagination,
    },
  });
};

export {initSwiperIntro};
